import React, { useState, useEffect } from 'react';
import {Drawer, Typography, Button} from 'antd';
import BottomButton from '../../Buttons/BottomButton';
import { useLocation } from 'react-router-dom';
import {  UploadOutlined } from '@ant-design/icons';


function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

const { Text } = Typography;

function DocumentsErrorDrawer({open, setShowDocumentsErrorDrawer, errorData, nativeNavigationUrl}) {
    const location = useLocation();
    const [processedErrors, setProcessedErrors] = useState([]);

    const closeDrawer = () => {
        setShowDocumentsErrorDrawer(false);
    };

    useEffect(() => {
        let errors = [];

        for (let i=0;i<errorData.length;i++) {
            const errorSplit = errorData[i].split("-");
            if (errorSplit.length > 1) {
                errors.push({errorText: errorSplit[0], subText:errorSplit[1]});
            } else {
                errors.push({errorText: errorSplit[0], subText:''});
            }
        }
        setProcessedErrors(errors);
    }, [errorData])
    

  return (
    <Drawer
        title="Document Errors"
        open={open}
        onClose={closeDrawer}
        key="documentErrorDrawer"
        placement="bottom"
        closable={true}
        bodyStyle={{padding:0}}
        height="50%"
        footer={[
            <BottomButton buttonText="Continue" callBackFunction={closeDrawer}/>
          ]}
      >
        <div className='job-details-modal-container error-drawer-container'>
            <div className='job-type'>
                <Text className="job-detail-title error-heading">There is an error with the following documents</Text>
                <div className='job-detail-content document-errors-div'>
                {
                    processedErrors.length ? 
                    processedErrors.map(item => {
                        return (
                            <div className='error-section' key={item.errorText}>
                                <div className='error-text-content'>
                                    <Text className='error-text'>{item.errorText}</Text>
                                    {
                                        item.subText ? <Text className='error-subtext'>{item.subText}</Text> : null
                                    }  
                                </div>
                                <a 
                                className={`hyperlink-anchor`} 
                                href={`${nativeNavigationUrl}${parseInt(localStorage.getItem("appVersion")) > 66 ? `&entryVia=${location.pathname.substring(1)}` : ''}`}>
                                    <Button className="timeline-button">
                                        <div className='button-content'>
                                            <UploadOutlined style={{color:'#D34612'}}/>
                                            <Text className='re-upload-text'>Re-Upload</Text>
                                        </div>
                                    </Button>
                                </a>
                            </div>
                        )
                    }): null
                }
                </div>
            </div>
        </div>
      </Drawer>
  )
}

export default DocumentsErrorDrawer;
